import { gql } from '@apollo/client';

export interface ISvgOrImage {
  description?: string;
  contentType: string;
  url: string;
  filename: string;
  height: string;
  width: string;
  title: string;
}

export interface IImageWrapperSvg {
  content: string;
  originalContent: string;
  dataURI: string;
  absolutePath: string;
  relativePath: string;
}

export interface IImageWrapperFile {
  contentType: string;
  url: string;
  filename: string;
}

export const SvgFragment = gql`
  fragment Svg on Asset {
    description
    height
    width
    title
    contentType
    url
    fileName
  }
`;
